export function createDemoQrController({
  imageUrl,
  targetDocument = document,
}) {
  const root = targetDocument.createElement("aside");
  root.className = "demo-qr";
  root.setAttribute("aria-hidden", "true");

  const copy = targetDocument.createElement("div");
  copy.className = "demo-qr__copy";

  const eyebrow = targetDocument.createElement("p");
  eyebrow.className = "demo-qr__eyebrow";
  eyebrow.textContent = "Steinexpo";

  const hint = targetDocument.createElement("p");
  hint.className = "demo-qr__hint";
  hint.textContent = "QR-Code scannen und Infos zur Messe erhalten.";

  const code = targetDocument.createElement("div");
  code.className = "demo-qr__code";

  const image = targetDocument.createElement("img");
  image.className = "demo-qr__image";
  image.src = imageUrl;
  image.alt = "QR-Code mit Informationen zur Steinexpo";

  copy.append(eyebrow, hint);
  code.append(image);
  root.append(copy, code);
  targetDocument.body.append(root);

  return {
    show() {
      root.classList.add("is-visible");
      root.setAttribute("aria-hidden", "false");
    },
    hide() {
      root.classList.remove("is-visible");
      root.setAttribute("aria-hidden", "true");
    },
    destroy() {
      root.remove();
    },
  };
}
